// extracted by mini-css-extract-plugin
export default {"container":"FooterNavbar_container__WH44J","separator":"FooterNavbar_separator__KfNiV","activeLink":"FooterNavbar_activeLink__QSoEL","loading":"FooterNavbar_loading__97URk"};